// extracted by mini-css-extract-plugin
export default {"td":"aAJZMURO6a8TzCgboWfB","tr":"xXwShV5b87GoS0jhhPjw"};